module.exports = __webpack_public_path__ + "img/rpd_halfbadge.d57e58d6.png";